import * as boHelper              from '../batchOperationDialogActionsHelper';
import * as partsService from '../../../services/Parts/partsService';
/////////////////////////////////////////
// ACTION TYPES - PUBLIC, FOR REDUCERS
export const actionTypes = {
  ...boHelper.getActionTypes('EDIT_ASSETS_STATUS_DIALOG'),
};

////////////////////////////////////////////////////////////////
// PLAIN ACTION CREATORS - PRIVATE, FOR LOCAL DISPATCH ONLY
const actions = {
  ...boHelper.getActions('EDIT_ASSETS_STATUS_DIALOG'),
};

/////////////////////////////////////////////////////////////////////////
// API METHODS - PUBLIC, FOR OTHER ACTION MODULES (and internal use)
const config = {
  submitMethod: partsService.updatePartsStatus,
  dialogReduxStorageName: 'editAssetsStatusDialog'
};

export let api = {
  ...boHelper.getApiActions(actions, config),
};

/////////////////////////////////////////////////////////////////////
// METHODS FOR JSX PROPS - PUBLIC, ALL THUNK TYPE
export let jsxActions = {
  ...boHelper.getJsxActions(api)
};


